import axios from 'axios';

export const twinfieldService = {
  async getAuthorizeUrl() {
    const response = await axios.get('/integrations/twinfield/authorize-url');
    return response.data;
  },

  async getStatus() {
    const response = await axios.get('/integrations/twinfield/status');
    return response.data;
  },

  async update(payload) {
    const response = await axios.patch('/integrations/twinfield', payload);
    return response.data;
  },

  async disconnect() {
    const response = await axios.delete('/integrations/twinfield');
    return response.data;
  },

  async listOffices() {
    const response = await axios.get('/integrations/twinfield/offices');
    return response.data;
  },

  async listGrootboekrekeningen() {
    const response = await axios.get('/integrations/twinfield/grootboekrekeningen');
    return response.data;
  },

  async listVatCodes() {
    const response = await axios.get('/integrations/twinfield/vat-codes');
    return response.data;
  },

  async listJournals() {
    const response = await axios.get('/integrations/twinfield/journals');
    return response.data;
  },
};

export default twinfieldService;
